module.exports = __webpack_public_path__ + "img/HERO-head-06-tida.785bb068.png";